import React from 'react';
import { Link } from 'react-router-dom';
import HeaderSlider from '../../pages/HeaderSlider';

const SecurityGuard = () => {
    return (
        <>
            {/* <!-- Breadcromb Area Start --> */}
            <section className="bleezy-breadcromb-area">
                <HeaderSlider src="../../assets/img/Gallery/Securityguard3.jpeg" title="Security Guard" />

                {/* <div className="breadcromb-top section_50 security-guard-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-top-text">
                                    <h2 className="banner-heading">Security Guard</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="breadcromb-bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="breadcromb-bottom-text">
                                    <ul>
                                        <li><Link to="/">home</Link></li>
                                        <li><a href="#"><i className="fa fa-long-arrow-right"></i></a></li>
                                        <li>Security Guard</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Breadcromb Area End --> */}

            <section class="bleezy-blog-page-area" style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <div class="container">
                    <div class="mid-title  mb-5 "><h2 class="heading-with-border"><strong>Security Guard</strong></h2>
                        <h3 className="sub-heading-page" style={{ marginBottom: '10px' }}><strong>Manned Guarding Service – Armed and Unarmed</strong></h3>
                        <p className="octo-para">
                            Security Guard is omnipresent and can be found anywhere, be it a commercial establishment or a residential unit. They have become an indispensable part of our society. Security Guard is highly effective in protecting life and property which cannot be replaced by any electronic gadget. We are amongst the best security guard provider in India.
                        </p>
                        <p className="octo-para" style={{ marginTop: '18px' }}>
                            We provide following type of Security Personnel:
                        </p>
                        <ul class="list">
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Security Guard.</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Head Guard</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Security Supervisor</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Assistant Security Officer</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Security Officer</li>
                            <li className='octo-para'><i class="fa fa-check theme-color"></i>  Armed Guard</li>

                        </ul>

                        <h3 className="sub-heading-page" style={{ marginTop: '15px', marginBottom: '15px' }}><strong> Security Guard</strong></h3>
                        <p className="octo-para">A Security Guard in the Private Security Sector form the first level of defence, who notices and encounters threats and risks that are detrimental to life, property and premises. Security Guard is responsible for monitoring premises and property through physical presence and by using security and protection systems. We are consistently ranked as top security guard provider in India for providing high quality security guards.
                        </p>

                        <h3 className="sub-heading-page" style={{ marginTop: '15px', marginBottom: '10px' }}><strong>Security Supervisor</strong></h3>
                        <p className="octo-para">Security Supervisor in the Private Security Sector is the first executive, who apart from his own duties has operational and administrative responsibilities towards a security unit. He allots duties to security guards and supervise their day to day work. He reports to security officer.</p>

                        <h3 className="sub-heading-page" style={{ marginTop: '15px', marginBottom: '10px' }}><strong>Security Officer</strong></h3>
                        <p className="octo-para">A Security Officer is required when the strength of security personnel is higher and complex job, such as handling entire unit on its own, training on regular basis, reporting writing, etc., is involved. Security officer is in charge of entire security operation of a unit. He reports to operation manager.</p>
                        <h3 className="sub-heading-page" style={{ marginTop: '15px', marginBottom: '10px' }}><strong>Armed Guard</strong></h3>
                        <p className="octo-para">An Armed guard is preferred when threat perception or risk factor is higher and guarding of valuables or VIP is required. Presence of guard with armed, work as a deterrent and prevents crime. Arm guard is required to use his weapon judiciously to protect life and property.</p>

                        <p className="octo-para" style={{ marginTop: '20px', marginBottom: '10px' }}>We provide professional, trained, disciplined and uniformed security to take care of your business in most efficient and economical way. If you are looking to create your own army of security or upgrade your existing security setup, within an economical budget, call us for a free consultation and free (non committed) quote.</p>
                    </div>
                </div>
            </section>



        </>
    )
}

export default SecurityGuard;
